import cimigoLogo from "@/assets/img/logo-Ask-Cimigo.svg";
import iconVietNam from "@/assets/img/icons/icon-Viet-Nam.svg";
import iconExpandMore from "@/assets/img/icons/icon_expand_more.svg";
import iconPerson from "@/assets/img/icons/person_outline.svg";
import iconSubscription from "@/assets/img/icons/credit_card_300.svg";
import iconTeam from "@/assets/img/icons/team.svg";
import iconLock from "@/assets/img/icons/new_lock.svg";
import iconTranslate from "@/assets/img/icons/translate.svg";
import iconStar from "@/assets/img/icons/star.svg";
import iconReport from "@/assets/img/icons/report_views.svg";
import iconBookmark from "@/assets/img/icons/bookmark.svg";
import iconLogout from "@/assets/img/icons/logout.svg";
import iconProfile from "@/assets/img/icons/ic-profile.svg";
import iconSearch from "@/assets/img/icons/icon-search.svg";
import icDouble from "@/assets/img/icons/ic-double.svg";
import frame from "@/assets/img/Frame.svg";
import icAccount from "@/assets/img/icons/account_balance.svg";
import icBadge from "@/assets/img/icons/badge.svg";
import icSchool from "@/assets/img/icons/school.svg";
import iconShopping from "@/assets/img/icons/shopping_basket.svg";
import iconCampaign from "@/assets/img/icons/campaign_nofill.svg";
import iconCampaign2 from "@/assets/img/icons/campaign_nofill_2.svg";
import iconHeart from "@/assets/img/icons/heart.svg";
import imageCimigo from "@/assets/img/image.png";
import iconPDF from "@/assets/img/icons/PDF.svg";
import imageCimigo2 from "@/assets/img/image_2.png";
import iconClose from "@/assets/img/icon/icClose.svg";
import cimigoLogo2 from "@/assets/logo/cimigo_logo_2.svg";
import iconSuccess from "@/assets/img/icon/ic-Success.svg";
import imageCimigo3 from "@/assets/img/image-cimigo.svg";
import imagePowerBI from "@/assets/img/image_PowerBI.svg";
import imageDetailContent from "@/assets/img/image_detail_content.svg";
import imageHomePage from "@/assets/img/image_home.svg";
import imagePDFDetail from "@/assets/img/image_pdf_detail.svg";
import imageTitle1 from "@/assets/img/image_title.svg";
import imageTitle2 from "@/assets/img/image_title_2.svg";
import imageEllipse from "@/assets/img/Ellipse.svg";
import logoLoading from "@/assets/img/logo-50x50.png";
import iconBadgeSvgrepo from "@/assets/img/icons/badge-svgrepo.svg";
import imageNullValue from "@/assets/img/imageNullValue.svg";
import iconNY from "@/assets/img/icons/IconAmerica.jpg";
import iconEN from "@/assets/img/icons/iconEngland.png";
import iconID from "@/assets/img/icons/iconIndonesia.png";
import imageBI from "@/assets/img/imageBI.jpg";
import iconFavorite from "@/assets/img/icons/favorite.svg";
import iconFullscreen from "@/assets/img/fullscreen.svg";
import iconNotFound from "@/assets/img/Not-Found.jpg";
import bannerTransparent from "@/assets/img/Banner_Transparent2.png";
import bannerCimigo from "@/assets/img/AskCimiLogo.png"
import logoAi from "@/assets/logo/AskCimigo-ai.png"
const image = {
  bannerTransparent,
  cimigoLogo,
  iconVietNam,
  iconExpandMore,
  iconPerson,
  iconSubscription,
  iconTeam,
  iconLock,
  iconTranslate,
  iconStar,
  iconReport,
  iconBookmark,
  iconLogout,
  iconProfile,
  iconSearch,
  icDouble,
  frame,
  iconShopping,
  icSchool,
  icBadge,
  icAccount,
  iconCampaign,
  iconHeart,
  imageCimigo,
  iconPDF,
  iconCampaign2,
  imageCimigo2,
  iconClose,
  cimigoLogo2,
  iconSuccess,
  icGoogle: "/assets/img/icon/ic-google.svg",
  icMicrosoft: "/assets/img/icon/ic-microsoft.svg",
  imageCimigo3,
  imagePowerBI,
  imageDetailContent,
  imageHomePage,
  imagePDFDetail,
  imageTitle1,
  imageTitle2,
  imageEllipse,
  logoLoading,
  iconBadgeSvgrepo,
  imageNullValue,
  iconEN,
  iconID,
  iconNY,
  imageBI,
  iconFavorite,
  iconFullscreen,
  iconNotFound,
  bannerCimigo,
  logoAi
};

export default image;
